/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_UnsubscribeInputs */

const th_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หยุดรับอีเมลประเภทนี้:`)
};

const en_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop receiving these emails:`)
};

const ja_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この種のメールの配信を停止する:`)
};

const zh_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退订这些邮件：`)
};

const es_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de recibir estos correos:`)
};

const pt_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de receber estes e-mails:`)
};

const id_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti menerima email ini:`)
};

const fr_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus recevoir ces e-mails :`)
};

const tl_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itigil ang mga email na ito:`)
};

const vi_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng nhận các email này:`)
};

const ko_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 메일 수신 중단:`)
};

const de_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese E-Mails abbestellen:`)
};

const ru_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отписаться от этих писем:`)
};

const tr_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu e-postaları almayı bırakın:`)
};

const it_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smetti di ricevere queste email:`)
};

const pl_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrezygnuj z tych wiadomości:`)
};

const uk_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відписатися від цих листів:`)
};

const hi_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ये ईमेल पाना बंद करें:`)
};

const ar_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيقاف هذه الرسائل:`)
};

const ms_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti menerima e-mel ini:`)
};

const bn_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ইমেলগুলি পাওয়া বন্ধ করুন:`)
};

const zh_tw2_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消訂閱這些郵件：`)
};

const zh_hk2_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消訂閱這些郵件：`)
};

const ur_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ ای میل بند کریں:`)
};

const fa_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دریافت این ایمیل‌ها را متوقف کنید:`)
};

const sw_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acha kupokea barua pepe hizi:`)
};

const nl_email_unsubscribe = /** @type {(inputs: Email_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop deze e-mails:`)
};

/**
* | output |
* | --- |
* | "Stop receiving these emails:" |
*
* @param {Email_UnsubscribeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_unsubscribe = /** @type {((inputs?: Email_UnsubscribeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_UnsubscribeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_unsubscribe(inputs)
	if (locale === "ja") return ja_email_unsubscribe(inputs)
	if (locale === "zh") return zh_email_unsubscribe(inputs)
	if (locale === "es") return es_email_unsubscribe(inputs)
	if (locale === "pt") return pt_email_unsubscribe(inputs)
	if (locale === "id") return id_email_unsubscribe(inputs)
	if (locale === "fr") return fr_email_unsubscribe(inputs)
	if (locale === "tl") return tl_email_unsubscribe(inputs)
	if (locale === "vi") return vi_email_unsubscribe(inputs)
	if (locale === "ko") return ko_email_unsubscribe(inputs)
	if (locale === "de") return de_email_unsubscribe(inputs)
	if (locale === "ru") return ru_email_unsubscribe(inputs)
	if (locale === "tr") return tr_email_unsubscribe(inputs)
	if (locale === "it") return it_email_unsubscribe(inputs)
	if (locale === "pl") return pl_email_unsubscribe(inputs)
	if (locale === "uk") return uk_email_unsubscribe(inputs)
	if (locale === "hi") return hi_email_unsubscribe(inputs)
	if (locale === "ar") return ar_email_unsubscribe(inputs)
	if (locale === "ms") return ms_email_unsubscribe(inputs)
	if (locale === "bn") return bn_email_unsubscribe(inputs)
	if (locale === "zh-TW") return zh_tw2_email_unsubscribe(inputs)
	if (locale === "zh-HK") return zh_hk2_email_unsubscribe(inputs)
	if (locale === "ur") return ur_email_unsubscribe(inputs)
	if (locale === "fa") return fa_email_unsubscribe(inputs)
	if (locale === "sw") return sw_email_unsubscribe(inputs)
	if (locale === "nl") return nl_email_unsubscribe(inputs)
	return en_email_unsubscribe(inputs)
});